import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RiskEvaluationService {

    constructor(private http: HttpClient) {

    }

    getQuestionMasterBoardEvalList(): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getEvaluationQuestion')
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

       getRiskDepartmentList(): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getRiskDepartment')
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }


    getQuestionByQuestionID(questionID): Promise<any> {
        return this.http.get(environment.clientUrl + 'companyMaster/companyData')
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    getEvaluationTypeList(): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getEvaluationTypeList')
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    getEvaluationCriteriaByEvalIdList(EvaluationTypeId): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getEvalCriteriaListByEvalTypeID/' + EvaluationTypeId)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    getEvaluationQuestionsByCriteriaIdList(EvaluationCriteriaID): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getEvaluationQuestionByCriteriaId/' + EvaluationCriteriaID)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    updateEvaluationFormEndDate(dateObject): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/updateEvaluationFormEndDate', (dateObject))
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    //board Entity Evaluation Forms
    getEvaluationFormDetailList(): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getEvaluationFormList')
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    sendForReviewEvalutionQuestionnaire(reviewObject): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/sendForReview', (reviewObject))
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    addQuestionDetails(newQuestion): Promise<any> {
        //var headers = new Headers();
        //head('Content-Type', 'application/json');
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/addEvaluationQuestion', (newQuestion))
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    addRiskDepartment(newQuestion): Promise<any> {
        //var headers = new Headers();
        //head('Content-Type', 'application/json');
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/addRiskDepartment', (newQuestion))
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    getQuestionListByEvaluationTypeIdAndEvaultionCriteriaID(EvaluationTypeId, EvaluationCriteriaID): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getEvaluationQuestion/' + EvaluationTypeId + '/' + EvaluationCriteriaID)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

       getRiskDepartmentByEvaluationTypeIdAndEvaultionCriteriaID(EvaluationTypeId, EvaluationCriteriaID): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getRiskDepartment/' + EvaluationTypeId + '/' + EvaluationCriteriaID)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

        getRiskDescriptionByEvaluationTypeIdAndEvaultionCriteriaID(EvaluationTypeId, EvaluationCriteriaID): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getRiskDepartment/' + EvaluationTypeId + '/' + EvaluationCriteriaID)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    updateEvaluationQuestionDetails(questionObject): Promise<any> {
        //var headers = new Headers();
        //head('Content-Type', 'application/json');
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/updateEvaluationQuestion', (questionObject))
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    updateEvaluationDepartment(questionObject): Promise<any> {
        //var headers = new Headers();
        //head('Content-Type', 'application/json');
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/updateRiskDepartment', (questionObject))
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    deleteQuestionDetails(questionId): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/deleteQueestionDetails?questionID=' + questionId)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    deleteDepartment(deptID): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/deleteRiskDepartmentDetails?riskDepartmentID=' + deptID)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    saveBoardEntityForm(entityFormObject): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/createEvaluationSetupForm', entityFormObject)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    getEvaluationFormList(): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getEvaluationFormList')
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    getEvaluationCriteriaList(): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getEvaluationCriteriaList')
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }



    getListOfEvaluationFormsCreatedByUserId(userId): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getEvaluationFormListToAssignBycreatedById/' + userId)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    // to get Reviewers Details By FormId

    getReviewersDetailsEvaluationForm(formId): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getReviewersDetailsEvaluationForm/' + formId)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    assignEvaluationFormToAssingee(assigneeObject): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/assignEvaluationForm', assigneeObject)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }



    getAssignedFormsByuserId(userId): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/assignEvaluationFormByUserId/' + userId)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    reviewApproved(entityFormObject): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/approveReviewStatusEvaluationFormByUserId', entityFormObject)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    updateEvaluationForm(formObject): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/updateEvaluationSetupForm', formObject)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    getListOfAssigneeForm(): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getAssignedEvaluationForms')
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    getListOfAssigneeForMonitoring(): Promise<any> {

        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getQuestionnaireForMonitoring')
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    getListOfAssigneeStatusFormByPeriodParameter(period): Promise<any> {
        var periodObject = {
            'periodParameter': period
        }
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/getQuestionnaireForMonitoringByPeriodParamter', periodObject)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

        getRiskMatrixNameByRiskMatrix(matrixtype): Promise<any> {
        var matrixtypeObject = {
            'RiskMatrix': matrixtype
        }
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/getEvaluationMatrixByRiskMatrix', matrixtypeObject)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    updateEvaluationMonitoringAssignee(assigneeObject): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/updateAssignedId', assigneeObject)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    getViewSubmittedQuestionList(assignedFormId): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/viewAssignedEvaluationFormDetails/' + assignedFormId)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    // getIndividualReport(evalObject): Promise<any> {

    //     return this.http.post(environment.clientUrl + 'riskEvaluationMaster/getIndividualReport', evalObject)
    //         .toPromise()
    //         .then(response => {
    //             return Promise.resolve(response);
    //         })
    // }

    getIndividualReport(evalObject: any): Promise<any> {
        return this.http.post<any>(`${environment.clientUrl}riskEvaluationMaster/getIndividualReport`, evalObject).toPromise();
    }



    getIndividualReportList(userId): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getReportsListByAssesseeId/' + userId)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }



    updateReviewerComments(questionObject): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/updateReviewerComment', questionObject)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    getFormDetailsByFormId(formId): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getReviewersDetailsEvaluationForm/' + formId)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    // to created assignment of Evaluation forms in assigneeStatus
    createAssigneeStatus(AssesseeObject): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/AssigneeStatus', AssesseeObject)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    updateAssigneeStatus(AssesseeObject): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/UpdateAssigneeStatus', AssesseeObject)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    publishMonitoringScreen(publishObject): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/publishEvaluation', publishObject)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }


    getPeriodParameterList(): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getPeriodParameterList')
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    getSummaryReportDetails(periodParameter): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/generateSummaryReport', { "periodParameter": periodParameter })
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    getStatusOfAssesorsList(object): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/statusOfAssesors', object)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    updateReportsToGenerate(object): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/updateReportsToGenerate', object)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    // to get evaluation assignment Status form by Id
    getAssignmentStatusFormDetailsById(object): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/getAssignmentStatusForm', object)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    // to downloadReport 
    downloadReport(object): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/downloadReport', object)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    // to delete questionnaire
    deleteQuestionnaireById(evaluationFormId): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/deleteQuestionnaire/' + evaluationFormId)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    getRiskMatrixList(): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getEvaluationMatrixList')
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    addRiskMatrix(newMatrix): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/addRiskEvaluationMatrix', (newMatrix))
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })

}

updateEvaluationMatrix(matrixObject): Promise<any> {
    return this.http.post(environment.clientUrl + 'riskEvaluationMaster/updateEvaluationMatrix', (matrixObject))
        .toPromise()
        .then(response => {
            return Promise.resolve(response);
        })
    }

deleteMatrix(matrixId): Promise<any> {
    return this.http.get(environment.clientUrl + 'riskEvaluationMaster/deleteEvaluationMatrix?matrixID=' + matrixId)
        .toPromise()
        .then(response => {
            return Promise.resolve(response);
        })
    }
}
